import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en.json";
import translationDE from "./locales/de.json";

const resources = {
  en: { translation: translationEN },
  de: { translation: translationDE },
};

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources,
        supportedLngs: ['de', 'en'],  // pick best language
        // lng: "en", // Standard-Sprache

        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },

        // Options for LanguageDetector
        detection: {
            //order: ['cookie', 'localStorage', 'sessionStorage', 'navigator'],
            order: ['cookie', 'localStorage', 'navigator'],

            // defaults:
            //lookupQuerystring: 'lng',
            //lookupCookie: 'i18next',
            //lookupLocalStorage: 'i18nextLng',
            //lookupSessionStorage: 'i18nextLng',
            //lookupFromPathIndex: 0,
            //lookupFromSubdomainIndex: 0,

            caches: ['localStorage', 'cookie'],  // use also cookies
            // excludeCacheFor: ['cimode']       // default       

        }
    });

console.log("->" + i18n.language);    

export default i18n; 

/*

// merkt sich Sprache nicht

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "./locales/en.json";
import translationDE from "./locales/de.json";

const resources = {
  en: { translation: translationEN },
  de: { translation: translationDE },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "en", // Standard-Sprache
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },
    });

console.log("->" + i18n.language);    

export default i18n; 
*/